'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { VehicleFilterPanel } from '@/components/Vehilces/VehicleFilters/VehicleFilterPanel';
import { VehicleGrid } from '@/components/Vehilces/VehicleGrid';
import type { CmsVehicle } from '@/services/cms/models/CmsVehicle';
export interface VehicleFilterGridProps {
  vehicles: CmsVehicle[];
  enquireFormOnCompleteMessage?: string;
  siteId?: number;
}
export function VehicleFilterGrid(t0) {
  const $ = _c(12);
  const {
    vehicles,
    enquireFormOnCompleteMessage,
    siteId
  } = t0;
  const [vehiclesState, setVehiclesState] = React.useState(vehicles);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = vehicles_0 => setVehiclesState(vehicles_0);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== vehicles) {
    t2 = <VehicleFilterPanel vehicles={vehicles} onVehiclesFiltered={t1} />;
    $[1] = vehicles;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minHeight: 300,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Card sx={t3}><CardContent><SearchOffIcon sx={{
          fontSize: 56,
          color: "text.secondary",
          mb: 2
        }} /><Typography variant="h6" color="text.secondary" gutterBottom={true}>No vehicles found</Typography><Typography variant="body2" color="text.secondary">Try adjusting your filters or search terms.</Typography></CardContent></Card>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== enquireFormOnCompleteMessage || $[6] !== siteId || $[7] !== vehiclesState) {
    t5 = <VehicleGrid vehicles={vehiclesState} enquireFormOnCompleteMessage={enquireFormOnCompleteMessage} siteId={siteId} noResults={t4} />;
    $[5] = enquireFormOnCompleteMessage;
    $[6] = siteId;
    $[7] = vehiclesState;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}